import { render, staticRenderFns } from "./nonTournament.vue?vue&type=template&id=036d1bee&scoped=true"
import script from "./nonTournament.vue?vue&type=script&lang=js"
export * from "./nonTournament.vue?vue&type=script&lang=js"
import style0 from "./nonTournament.vue?vue&type=style&index=0&id=036d1bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d1bee",
  null
  
)

export default component.exports